export const testimonials = [
  {
    name: '张先生',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20warm%20studio%20lighting%2C%20friendly%20smile%2C%20clean%20cream%20background%2C%20business%20casual%20attire&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '这个平台真的太棒了！视频质量非常高，分类也很清晰。我最喜欢纪录片频道，已经在这里看了好几部关于中国传统文化的精彩纪录片，每一部都制作精良，收获满满。',
    date: '2026-06-15',
  },
  {
    name: '李女士',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20portrait%2C%20warm%20natural%20lighting%2C%20genuine%20smile%2C%20soft%20cream%20background%2C%20modern%20professional%20look&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为影视爱好者，这里满足了我对国产精品视频的所有期待。短片频道的创意作品尤其惊艳，每一部都充满艺术感。强烈推荐给所有喜欢优质内容的朋友！',
    date: '2026-05-28',
  },
  {
    name: '王同学',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%2C%20bright%20natural%20light%2C%20youthful%20and%20energetic%20expression%2C%20clean%20light%20background%2C%20casual%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '综艺频道的节目太有趣了！每周末都会和朋友一起看，从才艺竞技到音乐节目，制作水准完全不输电视综艺。页面体验也很流畅，看视频从不卡顿。',
    date: '2026-06-02',
  },
  {
    name: '赵老师',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20scholar%20portrait%2C%20warm%20library%20lighting%2C%20thoughtful%20expression%2C%20cream%20background%2C%20intellectual%20style%20with%20glasses&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '我经常在课堂上推荐这个网站给学生们。剧情片频道有很多优秀的国产作品，对于理解当代中国社会和文化非常有帮助。内容筛选很用心，值得信赖。',
    date: '2026-05-10',
  },
  {
    name: '陈女士',
    location: '深圳',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20female%20professional%20portrait%2C%20warm%20studio%20light%2C%20confident%20smile%2C%20soft%20neutral%20background%2C%20contemporary%20business%20attire&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 4,
    content: '每天下班后都会来这里看看短片放松一下。十几分钟的长度刚刚好，不会太长也不会太短。希望平台能继续丰富短片频道的内容，期待更多佳作！',
    date: '2026-06-10',
  },
];

export const stats = [
  { label: '精选视频', value: '10,000+' },
  { label: '活跃用户', value: '500万+' },
  { label: '日均播放', value: '300万+' },
  { label: '合作导演', value: '2,000+' },
];